import { render } from "./beranda-index.vue?vue&type=template&id=46ffed05"
import script from "./beranda-index.vue?vue&type=script&lang=js"
export * from "./beranda-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__